import MerchantSkeleton from "../skeletons/MerchantSkeleton";
import RenderKeyValuePairs from "./RenderKeyValuePairs";

function LegalDetails({merchantLoading, entity}) {
    return (
        <div className="legal-details mb-4">
            {merchantLoading ? (
                <>
                    <MerchantSkeleton/>
                    <MerchantSkeleton/>
                </>
            ) : (
                <div className="row mt-5 ps-4">
                    <div className="col-12 title">LEGAL INFORMATION</div>
                    <div className="ps-5">
                        <RenderKeyValuePairs obj={entity}/>
                    </div>
                </div>
            )}
        </div>
    );

}

export default LegalDetails;